<template>
  <div class="user-about-block">
    <template v-if="user.birthday && user.birthday_visible">
      <div>{{ $t('user-about.date-birth') }}</div>
      <span>{{ birthday }}</span>
    </template>

    <template v-if="user.education">
      <div>{{ $t('user-about.education') }}</div>
      <span>
        {{ user.education }}
      </span>
    </template>

    <template v-if="user.degree">
      <div>{{ $t('user-about.degree') }}</div>
      <span>{{ user.degree }}</span>
    </template>

    <template v-if="workPlace.length">
      <div>{{ $t('user-about.work-place') }}</div>
      <span v-for="(work, i) in workPlace" :key="i">{{ work }}</span>
    </template>

    <!--<div></div>
        <span>Foreign trade academy <span>L.M. / Master of laws</span></span>-->

    <template v-if="user.position">
      <div>{{ $t('user-about.position') }}</div>
      <span>{{ user.position }}</span>
    </template>

    <template v-if="user.specialization">
      <div>{{ $t('user-about.specialization') }}</div>
      <span>{{ user.specialization }}</span>
    </template>

    <template v-if="user.country">
      <div>{{ $t('user-about.location') }}</div>
      <span>
        <Location :country="user.country" />
      </span>
    </template>

    <slot></slot>
  </div>
</template>

<script>
import moment from 'moment'
import { getAge } from '@/utils/date'
import Location from '@/components/user/Location'

export default {
  name: 'UserAbout',
  components: { Location },
  props: {
    user: Object,
  },
  computed: {
    birthday() {
      const m = moment(this.user.birthday)
      const date = m.format('MMMM DD, YYYY')
      const age = getAge(+m)
      return `${date} (${age} years)`
    },
    workPlace() {
      const list = this.user.work_place ?? []
      return list.filter((el) => el)
    },
  },
}
</script>

<style lang="scss">
.user-about-block {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 6px 46px;
  align-content: flex-start;

  font-weight: 400;
  font-size: 15px;
  line-height: 157.5%;
  color: #d0d0d0;

  div {
    color: $textLight;
    min-height: 24px;
  }

  span {
    display: block;
    color: #474747;
  }

  .user-location {
    justify-content: flex-start;
    color: $text;
  }

  a {
    color: $text;
  }
}
</style>
